<script lang="ts">
    import { onMount } from "svelte";
    import {
      currentRoute,
      userData,
      userSignedIn,
      showOverlay,
      isLoading,
    } from "./store";
    import "@shoelace-style/shoelace/dist/themes/light.css";
    import "@shoelace-style/shoelace/dist/shoelace.js";
    import "@shoelace-style/shoelace/dist/components/copy-button/copy-button.js"; // Import the component
    import { Router, Route, navigate } from "svelte-routing";
    import Home from "./pages/Home.svelte";
    import NotFound from "./pages/NotFound.svelte";
    import GoogleSignIn from "./GoogleSignIn.svelte";
    import GoogleSignOut from "./GoogleSignOut.svelte";
    import Analytics from "./components/Analytics.svelte";
    import Avatar from "svelte-avatar";
    let clientId =
      "487272841760-u6p84q3i1n106r92a198oud1tnk4tg92.apps.googleusercontent.com";
  
    function toggleOverlay() {
      showOverlay.update((n) => !n);
    }

  </script>
  
  <svelte:head>
    <meta name="google-signin-client_id" content={clientId} />
  </svelte:head>

<Router>
    <nav class="navbar">
      <div class="fixed-container">
        <div class="logo-container">
          <img src="./favicon.png" alt="TextCloaker Logo" class="logo-image" />
        </div>
        <p class="logo-text" style="font-size: x-large; font-weight: bold;">
          <a href="/">TextCloaker</a>
        </p>
        <div class="profile-container">
          <div class="profilePicture">
            <div class="logo-image" on:click={toggleOverlay}>
              <Avatar
                id="profilePicture"
                size="2.9rem"
                initials=""
                label="User avatar"
                src="./profile.png"
              ></Avatar>
            </div>
          </div>
          {#if $showOverlay && !$userSignedIn}
            <div class="profile-overlay">
              <p>Please Sign In!</p>
              <GoogleSignIn />
            </div>
          {/if}
          {#if $showOverlay && $userSignedIn && $userData}
            <div class="profile-overlay">
              <p>Welcome, {$userData.name}</p>
              <p>Email: {$userData.email}</p>
              <p>User ID: {$userData.id}</p>
              <GoogleSignOut />
            </div>
          {/if}
        </div>
      </div>
    </nav>
    <Route path="/" component={Home} />
    <Route path="*" component={NotFound} />
  </Router>
<Analytics />

